import {
  Flex,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { IoSearch } from "react-icons/io5";
import { useTranslation } from "react-i18next";

import GameSearchContent from "./GameSearchContent";

/**
 * GameSearch — 遊戲搜尋入口(header icon)+ 彈窗(移植自 911vip)
 * 點 icon 開 Modal,內容為 GameSearchContent;點結果會關閉彈窗。
 */
const GameSearch = () => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      {/* 固定浮動搜尋按鈕(比照 FloatButton:position fixed / 右下)*/}
      <Flex
        onClick={onOpen}
        position="fixed"
        bottom={{ base: "160px", md: "170px" }}
        right={{ base: "12px", md: "20px" }}
        zIndex={999999}
        cursor="pointer"
        align="center"
        justify="center"
        w={{ base: "46px", md: "56px" }}
        h={{ base: "46px", md: "56px" }}
        borderRadius="full"
        bgGradient="linear(to-b, #33cfff, #1477a8)"
        boxShadow="0 4px 12px rgba(0,0,0,0.4)"
        color="#04212e"
        _hover={{ filter: "brightness(1.08)" }}
        _active={{ transform: "scale(0.94)" }}
        transition="transform 0.1s, filter 0.15s"
        aria-label={t("common.search_games", "搜尋遊戲")}
      >
        <Icon as={IoSearch} boxSize={{ base: "24px", md: "30px" }} />
      </Flex>

      {isOpen && (
        <Modal
          blockScrollOnMount={false}
          isOpen={isOpen}
          onClose={onClose}
          size={"xl"}
          isCentered
        >
          <ModalOverlay bg="blackAlpha.700" backdropFilter="blur(4px)" />
          <ModalContent
            color="white"
            borderRadius="2xl"
            overflow="hidden"
            border="1px solid"
            borderColor="rgba(51,207,255,0.35)"
            bgGradient="linear(180deg, #0e3b54 0%, #08222f 100%)"
            boxShadow="0 24px 70px rgba(0,0,0,0.6)"
            my="auto"
            maxH="85vh"
          >
            {/* 頂部金色漸層條 */}
            <Flex
              h="3px"
              w="100%"
              bgGradient="linear(to-r, #1477a8, #33cfff, #1477a8)"
            />
            <ModalHeader
              display="flex"
              alignItems="center"
              gap={2}
              borderBottom="1px solid"
              borderColor="whiteAlpha.100"
            >
              <Icon as={IoSearch} color="#33cfff" />
              <Text fontSize="lg" fontWeight="800" letterSpacing="0.02em">
                {t("common.search_games", "遊戲搜尋")}
              </Text>
            </ModalHeader>
            <ModalCloseButton
              color="whiteAlpha.700"
              _hover={{ color: "white", bg: "whiteAlpha.100" }}
            />
            <ModalBody
              fontSize={{ base: "12px", md: "16px" }}
              overflowY="auto"
              minH={{ base: "360px", md: "440px" }}
              pb={4}
              pt={0}
              sx={{
                "&::-webkit-scrollbar": { width: "5px" },
                "&::-webkit-scrollbar-thumb": {
                  background: "#1477a8",
                  borderRadius: "10px",
                },
              }}
            >
              <GameSearchContent onClose={onClose} />
            </ModalBody>
          </ModalContent>
        </Modal>
      )}
    </>
  );
};

export default GameSearch;
